import authRoutes from 'modules/authentication/router'
import mainRoutes from 'modules/shared/router'
import isAuthenticatedGuard from 'modules/authentication/router/auth-guard'

const routes = [
  {
    path: '/auth',
    ...authRoutes
  },
  {
    path: '/',
    beforeEnter: [ isAuthenticatedGuard ],
    ...mainRoutes
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue')
  }
]

export default routes
